<div *ngIf="errorMessage" class="error" role="alert">{{ errorMessage }}</div>
<div *ngIf="successMessage" class="success" role="status" aria-live="polite">
  {{ successMessage }}
</div>

      <!-- File selection (Bootstrap input group) -->
      <div class="form-row">
          <input
            #nativeCostFileInput
            class="native-file-input"
            type="file"
            accept=".xlsx,.xls"
            (change)="onFileSelected($event)"
            aria-label="Choose Excel file"
            [disabled]="isUploading || isSavingPass"
          />

          <!-- Visible input group (shows filename + browse button) -->
          <div class="input-group file-input-group">
            <span class="input-group-text" id="file-addon">File</span>
            <input
              type="text"
              class="form-control"
              [value]="file?.name || ''"
              placeholder="Select .xlsx or .xls file"
              aria-describedby="file-addon"
              aria-readonly="true"
              readonly
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="openNativeFileDialog()"
              [disabled]="isUploading || isSavingPass"
              [attr.aria-label]="'Browse files'"
              title="Browse files"
            >
              <!-- paperclip icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                   fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M.5 6.5A3.5 3.5 0 0 1 4 3h7.5a2.5 2.5 0 1 1 0 5H6a1.5 1.5 0 0 1 0-3h5.5a.5.5 0 0 0 0-1H6a2.5 2.5 0 1 0 0 5h5.5a3.5 3.5 0 1 0 0-7H4A4.5 4.5 0 0 0-.5 6.5a4.5 4.5 0 1 0 9 0V4a.5.5 0 0 1 1 0v2.5a5.5 5.5 0 1 1-11 0Z"/>
              </svg>
              <span class="ms-1">Browse</span>
            </button>
          </div>

        <!-- Download Sample Excel & Last Updated -->
        <div style="margin-left: 43%;">
          <a
            class="btn btn-link px-0"
            href="assets/samples/Salary Dummy data.xlsx"
            download="Salary Dummy data.xlsx"
            [attr.aria-label]="'Download sample Excel'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M.5 9.9v2.6A2.5 2.5 0 0 0 3 15h10a2.5 2.5 0 0 0 2.5-2.5V9.9a.5.5 0 0 0-1 0v2.6A1.5 1.5 0 0 1 13 14H3a1.5 1.5 0 0 1-1.5-1.5V9.9a.5.5 0 0 0-1 0z"/>
              <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>
            <span class="ms-1">Download sample Excel</span>
          </a>
        </div>
      </div>

      <!-- Passphrase (Bootstrap input group with eye toggle) -->
      <div class="form-row">
        <label for="uploadPassInline" class="sr-only">Passphrase</label>
        <div class="input-group pass-input-group">
          <span class="input-group-text" id="pass-addon">Passphrase</span>
          <input
            #uploadPassInput
            id="uploadPassInline"
            class="form-control"
            [type]="showUploadPass ? 'text' : 'password'"
            placeholder="Enter passphrase (required)"
            autocomplete="off"
            aria-required="true"
            aria-describedby="pass-addon"
            [disabled]="isUploading || isSavingPass"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggle('upload')"
            [attr.aria-label]="showUploadPass ? 'Hide passphrase' : 'Show passphrase'"
            [attr.aria-pressed]="showUploadPass"
            [disabled]="isUploading || isSavingPass"
            title="{{ showUploadPass ? 'Hide' : 'Show' }}"
          >
            <svg *ngIf="!showUploadPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8ZM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/>
            </svg>
            <svg *ngIf="showUploadPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M13.359 11.238C14.32 10.337 15.078 9.262 15.5 8c-.858-2.572-3.5-5.5-7.5-5.5a7.028 7.028 0 0 0-2.79.588l.746.746A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.473-4.473l.823.823a2.5 2.5 0 0 1 2.827 2.827l.823.823ZM3.35 5.469c-.68.57-1.262 1.238-1.72 1.997A13.133 13.133 0 0 0 1.173 8c.363.974 1.043 2.007 2.01 2.977C4.474 12.332 6.235 13.5 8.355 13.5c.773 0 1.5-.17 2.156-.473l.749.421c-.881.36-1.835.552-2.905.552-4 0-6.642-2.928-7.5-5.5.36-1.08 1.081-2.234 2.111-3.2l.384.169Z"/>
              <path d="m2.146 1.146 12.708 12.708-.708.708L1.438 1.854l.708-.708Z"/>
            </svg>
          </button>
        </div>
        <div style="margin-left: 52%;">
          <label *ngIf="lastUpdatedOn">
            <small>Last updated on: {{ lastUpdatedOn | date: 'dd/MM/yyyy' }}</small>
          </label>
        </div>
      </div>

      <!-- Upload & Clear actions -->
      <div class="mt-2">
        <button
          class="btn btn-primary"
          (click)="uploadToServer()"
          [disabled]="!file || !isFileStructValid || rowValidationErrors.length > 0 || isUploading || isSavingPass"
          [attr.aria-busy]="isUploading"
        >
          <span class="spinner-border spinner-border-sm me-1" *ngIf="isUploading" role="status" aria-hidden="true"></span>
          <span>{{ isUploading ? 'Uploading…' : 'Upload Payroll Data' }}</span>
        </button>

        <!-- Clear button -->
        <button
          class="btn btn-secondary ms-2"
          type="button"
          (click)="onClearClick()"
          [disabled]="isUploading || isSavingPass"
          title="Clear selected file, preview and messages"
          aria-label="Clear selected file, preview and messages"
        >
          Clear
        </button>
      </div>

      <!-- Optional: show detailed structure issues -->
      <div *ngIf="!isFileStructValid && structureIssues.length" class="text-danger mt-2" aria-live="polite">
        <ul class="mb-0">
          <li *ngFor="let i of structureIssues">{{ i }}</li>
        </ul>
      </div>

<!-- UI Validation Error Table (GM Upload Style) -->
<div *ngIf="rowValidationErrors.length"
     class="p-3 mt-3"
     style="
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 6px;
        max-width: 1000px;
        margin: 0 auto;
     ">

    <div class="alert alert-danger mb-3">
        Excel validation failed. Found {{ rowValidationErrors.length }} issue(s).
    </div>

    <div class="table-responsive">
        <table class="table table-bordered table-striped table-sm mb-0">
            <thead style="background: #f8f9fa;">
                <tr>
                    <th style="width: 80px;">Row</th>
                    <th style="width: 150px;">DL</th>
                    <th style="width: 200px;">Location</th>
                    <th>Issue(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let err of rowValidationErrors">
                    <td>{{ err.rowNumber }}</td>
                    <td>{{ err.DL }}</td>
                    <td>{{ err.Location }}</td>
                    <td class="text-danger">
                      <div *ngFor="let issue of err.issues">
                        {{ issue }}
                      </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- 🔄 Scoped overlay for Cost Upload only -->
<div
  class="overlay\"
  *ngIf="isUploading"
  aria-live="polite"
  aria-busy="true"
  role="status"
>
  <div class="overlay-spinner" aria-hidden="true"></div>
  <div class="overlay-text">
    Uploading…
  </div>
</div>
